// src/components/Login.jsx (Updated with better styling)
import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { authAPI } from '../api/photoProcessingApi';
import './Login.css';

const logoUrl = process.env.PUBLIC_URL + "/android-chrome-192x192.png";

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    username: '',
    password_confirm: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isRegister, setIsRegister] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      let response;
      if (isRegister) {
        // Validate passwords match
        if (formData.password !== formData.password_confirm) {
          throw new Error("Passwords don't match");
        }
        response = await authAPI.register(formData);
      } else {
        response = await authAPI.login(formData.email, formData.password);
      }

      if (response.success) {
        onLogin(response.user);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleMode = () => {
    setIsRegister(!isRegister);
    setError('');
    setFormData({
      email: '',
      password: '',
      first_name: '',
      last_name: '',
      username: '',
      password_confirm: ''
    });
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={6} lg={5} xl={4}>
            <Card className="shadow-lg">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <img
                    src={logoUrl}
                    alt="Chrometrica"
                    className="text-primary"
                    style={{ width: '48px', height: '48px' }}
                  />
                  <h2 className="mt-3 mb-1">Chrometrica</h2>
                  <p className="text-muted">
                    {isRegister ? 'Create your account' : 'Sign in to your account'}
                  </p>
                </div>

                {error && (
                  <Alert variant="danger" className="mb-3">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    {error}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  {isRegister && (
                    <>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="first_name"
                              value={formData.first_name}
                              onChange={handleChange}
                              required
                              placeholder="Enter first name"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="last_name"
                              value={formData.last_name}
                              onChange={handleChange}
                              required
                              placeholder="Enter last name"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group className="mb-3">
                        <Form.Label>Username</Form.Label>
                        <Form.Control
                          type="text"
                          name="username"
                          value={formData.username}
                          onChange={handleChange}
                          required
                          placeholder="Choose a username"
                        />
                      </Form.Group>
                    </>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter email address"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      placeholder="Enter password"
                    />
                  </Form.Group>

                  {isRegister && (
                    <Form.Group className="mb-3">
                      <Form.Label>Confirm Password</Form.Label>
                      <Form.Control
                        type="password"
                        name="password_confirm"
                        value={formData.password_confirm}
                        onChange={handleChange}
                        required
                        placeholder="Confirm password"
                      />
                    </Form.Group>
                  )}

                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    className="w-100 mb-3"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        {isRegister ? 'Creating Account...' : 'Signing In...'}
                      </>
                    ) : (
                      <>
                        <i className={`bi ${isRegister ? 'bi-person-plus' : 'bi-box-arrow-in-right'} me-2`}></i>
                        {isRegister ? 'Create Account' : 'Sign In'}
                      </>
                    )}
                  </Button>
                </Form>

                <div className="text-center">
                  <Button
                    variant="link"
                    onClick={toggleMode}
                    className="text-decoration-none"
                  >
                    {isRegister
                      ? 'Already have an account? Sign in'
                      : "Don't have an account? Create one"
                    }
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;